import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-4 col-xxl-4" }
const _hoisted_2 = { class: "card custom-card" }
const _hoisted_3 = {
  class: "card-body",
  style: {"min-height":"340px"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "STATUS")
], -1)
const _hoisted_6 = { class: "col d-xxl-flex align-items-xxl-center justify-content-xxl-end" }
const _hoisted_7 = { class: "d-xxl-flex justify-content-xxl-center align-items-xxl-center status-btn text-right custom-status" }
const _hoisted_8 = {
  class: "text-center d-xxl-flex",
  style: {"margin-top":"8px","text-align":"right !important"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"margin-top":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Reward")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }, [
    /*#__PURE__*/_createElementVNode("h5", {
      class: "font-normal",
      style: {"text-align":"right"}
    }, "20 $BOO/day")
  ])
], -1)
const _hoisted_10 = {
  class: "row",
  style: {"margin-top":"0px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Staked GKD")
], -1)
const _hoisted_12 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_13 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_14 = {
  class: "row",
  style: {"margin-top":"0px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Min. Staking Period")
], -1)
const _hoisted_16 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_17 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_18 = {
  class: "row",
  style: {"margin-top":"0px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Cooldown Ends")
], -1)
const _hoisted_20 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_21 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_22 = {
  class: "row",
  style: {"margin-top":"0px"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Accrued Reward")
], -1)
const _hoisted_24 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_25 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_26 = {
  class: "row",
  style: {"margin-top":"0px"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Paid Reward")
], -1)
const _hoisted_28 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_29 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_30 = {
  class: "row",
  style: {"margin-top":"20px"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Last Refresh")
], -1)
const _hoisted_32 = { class: "col d-xxl-flex justify-content-xxl-end align-items-xxl-center" }
const _hoisted_33 = {
  class: "font-normal",
  style: {"text-align":"right"}
}
const _hoisted_34 = {
  class: "row",
  style: {"margin-top":"20PX"}
}
const _hoisted_35 = { class: "col-md-5 col-xxl-5" }
const _hoisted_36 = { class: "col-md-7 col-xxl-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.parseFarmerState(_ctx.farmerAcc)), 1)
            ])
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.farmerAcc.gemsStaked), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.minStakingEndsTs)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.cooldownEndsTs)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.roundDecimals(_ctx.farmerAcc.rewardA.accruedReward)) + " $BOO", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.roundDecimals(_ctx.farmerAcc.rewardA.paidOutReward)) + " $BOO", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h5", _hoisted_33, _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.rewardA.fixedRate.lastUpdatedTs)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              style: {"width":"100%"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
            }, "REFRESH")
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              style: {"width":"100%"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('claim')))
            }, "CLAIM " + _toDisplayString(_ctx.roundDecimals(_ctx.reward)) + " $BOO", 1)
          ])
        ]),
        (_ctx.farmerState === 'staked')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-danger",
              type: "button",
              style: {"width":"100%","margin-top":"10PX"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('endStaking')))
            }, " END STAKING "))
          : _createCommentVNode("", true),
        (_ctx.farmerState === 'pendingCooldown')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-danger",
              type: "button",
              style: {"width":"100%","margin-top":"10PX"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('endStaking')))
            }, " END COOLDOWN "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}